"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBirthdayCakeOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M11 7h2v4h-2V7zM13.5 4.4c0 .884-.671 1.6-1.5 1.6-.828 0-1.5-.716-1.5-1.6C10.5 3.516 12 2 12 2s1.5 1.516 1.5 2.4z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M18 14H6v6h12v-6zM6 12a2 2 0 00-2 2v6a2 2 0 002 2h12a2 2 0 002-2v-6a2 2 0 00-2-2H6z' }),
    react_1.default.createElement("path", { d: 'M6 12h12a2 2 0 012 2v2.857s-.349.141-1 .141c-1.55 0-1.525-1-3.008-1s-1.459 1-2.992 1-1.475-1-3-1c-1.442 0-1.525 1-3 1-1.542 0-.992-1-3-.992V14a2 2 0 012-2z' }))); };
exports.default = SvgBirthdayCakeOutline;
//# sourceMappingURL=BirthdayCakeOutline.js.map